import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsService, ShareMessagesService, UtilService, VariablesService } from 'src/app/shared/services';
import { PremiumServicesComponent } from 'src/app/premium-services/premium-services.component';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { IFundraiser } from 'src/app/fundraiser/models/fundraiser.model';
import { MatButtonModule } from '@angular/material/button';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-premium-service-pitch-page',
  standalone: true,
  imports: [
    CommonModule,
    PremiumServicesComponent,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './premium-service-pitch-page.component.html',
  styleUrls: ['./premium-service-pitch-page.component.scss']
})
export class PremiumServicePitchPageComponent {


  constructor(
    private shareMessagesService: ShareMessagesService,
    private util: UtilService,
    private eventsService: EventsService,
    private router: Router,
    private variablesService: VariablesService
  ) {}


  isMobile = false;
  message;
  url;

  @Input() fundraiser: IFundraiser;
  @Input() type;
  @Input() campaignId;
  @Input() list;
  userData;
  info = {
    congratsContent: {
      title: '',
      desc: 'Share your fundraiser today to get your first contribution and put your campaign on path to success.'
    },
    whatsappShareContent: {
      shareTitle: 'Share on Whatsapp',
      desc: 'We’ve even created a ready-to-send message just for you!'
    },
    planDetails: {
      header: {
        title: 'Upgrade for a more successful fundraising experience',
        desc: 'Choose a plan with a variety of value added services and reach your fundraising goal faster'
      }
    },
    list: [
      '** Timelines apply only if correct documents are uploaded',
      'Campaign promotional support from Ketto begins once 30% of the goal amount is raised',
      'Once a new plan is activated, it cannot be upgraded or downgraded',
      'Once a plan is activated, it cannot be canceled'
    ]
  }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    if (this.util.isBrowser) {
      setTimeout(() => {
        this.util.scrollToTop();
      }, 1000);
      this.userData = JSON.parse(localStorage.getItem('userdata'));
      this.info.congratsContent.title = `Congratulations ${this.userData.full_name}! Your fundraiser is live.`
      if (this.isMobile) {
        this.info.congratsContent.desc = 'Share you fundraiser to get your first contribution';
      }
    }
  }

  goToFundraiser() {
    if (this.type === 'med') {
      const payload = {
        'eventName': 'skip_to_fundraiser',
        'event_type': 'campaign',
        'page_name': 'campaign_thank_you',
        'event_type_id': this.campaignId
      };
      this.eventsService.sendSystemEvent(payload).subscribe({next: 
        () => {
          this.router.navigate([`/fundraiser/${this.fundraiser.custom_tag}`], {});
        },
        error: (err) => {
          this.router.navigate([`/fundraiser/${this.fundraiser.custom_tag}`], {});
        }
      });
    } else {
      // const url = `${this.utilService.domain_details.domain_url}/manage/index.html#!/${this.campaignId}`;
      const url = environment.manage_domain + '/manage/' + this.campaignId + '/dashboard';
      this.util.nativeNavigation(url);
    }
    
  }

  async getWhatsAppMessage() {
    this.fundraiser = this.variablesService.fundraiser;
    if (this.fundraiser) {
      this.message = this.shareMessagesService.getWhatsAppMessage3(this.fundraiser);
      const whatsAppDomain = this.util.isMobile() ? 'wa.me' : 'web.whatsapp.com/send';
      this.url = `https://${whatsAppDomain}?text=${this.message}`;
      this.shareMessagesService.shareEvents('whatsapp share', 17);
      setTimeout(() => window.open(this.url, '_blank'), 0);
    }
  }

}
